import { useCallback, useEffect, useState } from "react";
import AgentPreferencesAPI from "../api/AgentPreferencesAPI";

const useAgentPreferenceApprovals = () => {
	const [pending, setPending] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const refresh = useCallback(async () => {
		setLoading(true);
		setError(null);

		try {
			const result = await AgentPreferencesAPI.getPendingSubmissions();
			setPending(result?.submissions || []);
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	const review = async (submissionId, status) => {
		try {
			await AgentPreferencesAPI.reviewSubmission(submissionId, status);
			await refresh();
			return { success: true };
		} catch (err) {
			return { success: false, error: err.message };
		}
	};

	return { pending, loading, error, refresh, review };
};

export default useAgentPreferenceApprovals;
